import JovTermsAndConditionsComponent from './JovTermsAndConditionsContainer';

export default JovTermsAndConditionsComponent;